
<div class="modal-header">
    <div *ngIf="showFileUpload==true">
        <h4 class="modal-title pull-left">Place Offer</h4>
    </div>
    <div *ngIf="showFileUpload==false">
        <h4 class="modal-title pull-left">Inquiry Form</h4>
    </div>
    <button type="button" class="close pull-right" aria-label="Close" (click)="modalRef.hide()">
        <span aria-hidden="true">&times;</span>
    </button>
</div>
<div class="modal-body">


    <div class="form-group">
        <label class="form-label">Name</label>
        <input class="form-control" #firstNameinput="ngModel" [(ngModel)]="placeOfferModel.Name" required type="text" readonly>

    </div>
    <div class="form-group">
        <label class="form-label">Email</label>
        <input class="form-control" #firstNameinput="ngModel" [(ngModel)]="placeOfferModel.Email" required type="text" readonly>

    </div>
    <div class="form-group">
        <label class="form-label">Phone</label>
        <input class="form-control" #firstNameinput="ngModel" [(ngModel)]="placeOfferModel.Phone" mask='(000) 000-0000' type="text" maxlength="20" readonly>
    </div>
    <div class="form-group" *ngIf="showFileUpload==true">
        <label class="form-label">Offer Price<span class="red">*</span></label>
        <input type="text" value="{{placeOfferInputModel.OfferPrice|number}}"  dropSpecialCharacters="false" currencyMask  [options]="{ prefix: '', thousands: ',', decimal: '.', align: 'left', allowNegative: 'true', allowZero: 'true', precision: '0', nullable: 'true'  }"  
               [(ngModel)]="placeOfferInputModel.OfferPrice" class="form-control ">
              <p class="redtext" *ngIf="(!OfferPriceValid)">Offer Price is required</p>
    </div>
    <div class="form-group" *ngIf="showFileUpload==true">
        <label class="form-label">Earnest Money Deposit<span class="red">*</span></label>
        <input type="text" value="{{placeOfferInputModel.EarnestMoneyDeposit|number}}" dropSpecialCharacters="false" currencyMask  [options]="{ prefix: '', thousands: ',', decimal: '.', align: 'left', allowNegative: 'true', allowZero: 'true', precision: '0', nullable: 'true'  }" 
               [(ngModel)]="placeOfferInputModel.EarnestMoneyDeposit" class="form-control ">
                <p class="redtext" *ngIf="(!EarnestMoneyDepositValid)">Earnest Money Deposit is required</p>
    </div>
    <div class="form-group" *ngIf="showFileUpload==true">
        <label class="form-label">Due Diligence Period<span class="red">*</span></label>
        <input type="text" [dropSpecialCharacters]="false" mask="999999999"
               [(ngModel)]="placeOfferInputModel.DueDiligencePeriod" class="form-control ">
        <p class="redtext" *ngIf="(!DueDiligencePeriodValid)">Due Diligence Period is required</p>
    </div>
    <div class="form-group" *ngIf="showFileUpload==true">
        <label class="form-label">Closing Period<span class="red">*</span></label>
        <input type="text" [dropSpecialCharacters]="false" mask="999999999"
               [(ngModel)]="placeOfferInputModel.ClosingPeriod" class="form-control ">
        <p class="redtext" *ngIf="(!ClosingPeriodValid)">Closing Period is required</p>
    </div>
    <div class="form-group">
        <label class="form-label">Comments</label>
        <textarea class="form-control" id="exampleFormControlTextarea1" [(ngModel)]="placeOfferInputModel.Comments" maxlength="500" rows="3"></textarea>
    </div>
    <div *ngIf="showFileUpload==true">
        <file-upload (selectedFilesListEmitter)=selectedFilesListEmitter($event) [uploadType]="fileUploadType" [extensionType]="fileExtensionType" [clearFilescounter]="clearFiles" [fileTypes] ="fileTypes"></file-upload>
        <label class="alert-danger">{{errorMessage}}</label>
    </div>
    <div class="text-right">

        <button class="btn btn-default btn-lg" (click)="modalRef.hide()">Cancel</button>

        <div *ngIf="showFileUpload==true" class="displayinlineblockdiv">
            <button class="btn btn-success btn-lg" (click)="savePlaceOffer(1)">Place Offer</button>

        </div>
        <div *ngIf="showFileUpload==false" class="displayinlineblockdiv">
            <button class="btn btn-success btn-lg" (click)="savePlaceOffer(2)">Submit Inquiry</button>
        </div>

    </div>
